import type { ConversationCreatedEventData } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { ConversationTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import SettingsIcon from "@redotech/redo-icons/settings-02.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { formatSentenceCase } from "@redotech/util/string";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

export const ConversationCreatedEvent = memo(function ConversationCreatedEvent({
  event,
  data,
}: {
  event: ConversationTimelineEventResponse;
  data: ConversationCreatedEventData;
}) {
  return (
    <Flex align="flex-start" className={styles.card} gap="sm">
      <Flex
        align="center"
        className={`${styles.icon} ${styles.iconGreen}`}
        justify="center"
      >
        <SettingsIcon />
      </Flex>
      <Flex className={styles.content} dir="column" gap="xxs">
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          Conversation created as {formatSentenceCase(data.status)}
        </Text>
        <EventTimestamp event={event} />
      </Flex>
    </Flex>
  );
});
